<template>
    <div @click="selectApplication"
            class="application cursor-pointer mt-0 mr-3 mb-3 text-center"
            :class="{
                'application--selected': isSelected,
                'application--disabled': isDisabled
            }"
    >
        <div class="application-icon-container d-flex justify-content-center align-items-center" :class="application.iconClass">
            <img :src="appLogoUrl" class="application-icon" :class="{'application--loading': isSelected}">
            <i v-if="isSelected" class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>
        <span class="d-block" style="font-weight: 600">
            {{ appType }}
        </span>
        <span v-if="application.multiInstance" class="d-block small text-secondary">
            {{ name }}
        </span>
    </div>
</template>

<script>
export default {
    name: "ApplicationEntry",
    props: {
        application: {
            type: Object,
            required: true
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            appNames: {
                dealer_crm: 'CRM',
                dealer_www: 'WWW',
                dealer_bms: 'BMS',
                dealer_bit: 'BIT',
                agro_crm: 'AgroCRM',
                dealer_admin: 'Admin',
                system: 'System',
                help: 'Pomoc',
                dealer_rms: 'RMS'
            },
        }
    },
    computed: {

        appType() {
            const appTypeNormalized = this.application.type.split('.')[0];

            if (this.appNames.hasOwnProperty(appTypeNormalized)) {
                return this.appNames[appTypeNormalized];
            }

            return appTypeNormalized;
        },

        name() {
            const app = this.application;

            if (app.name) {
                return app.name;
            }
            if (!app.domain) {
                return;
            }

            let domainParts = app.domain.split('.');
            domainParts.pop();
            if (domainParts.length === 1) {
                return this.parseDomainPart(domainParts[0]);
            }
            domainParts.pop();

            let name = '';
            for (let domainPart of domainParts) {
                name += this.parseDomainPart(domainPart) + ' ';
            }

            return name.trim()
        },

        appLogoUrl() {
            let appName = this.application.type.split('.')[0].replace('_', '-');

            if (this.appNames.hasOwnProperty(this.application.type.split('.')[0])) {
                return `/img/logo-${appName}.svg`;
            }

            return `/img/logo-default.svg`; // fallback logo
        },
    },

    methods: {


        parseDomainPart(domainPart) {
            let domainParts = domainPart.split('-');
            let name = '';
            for (let domainElement of domainParts) {
                name += domainElement.charAt(0).toUpperCase() + domainElement.slice(1) + ' ';
            }

            return name.trim();
        },

        selectApplication() {
            if (this.isDisabled) {
                return;
            }

            this.$emit('selectApplication', this.application);
        }
    }
}
</script>

<style scoped lang="scss">


.application {
    transition: all 0.2s ease-in-out;
    border-radius: 12px;
    position: relative;
    width: 70px;

    &--disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }

    &--loading {
        opacity: 0.1;
    }

    .text-secondary {
        max-width: 70px;
        word-wrap: break-word;
    }

    .application-icon-container {
        width: 70px;
        height: 70px;
        border-radius: 12px;
        position: relative;
    }

    .application-icon {
        max-width: 65%;
        max-height: 40%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .application-icon-bg-blue {
        background-color: #00b2e6;
        transition: 0.2s linear;

        &:hover {
            background-color: darken(#00b2e6, 5%);
        }
    }

    .application-icon-bg-red {
        background-color: #b10f1a;
        transition: 0.2s linear;

        &:hover {
            background-color: darken(#b10f1a, 5%);
        }
    }

    .application-icon-bg-purple {
        background-color: #5e3ed1;
        transition: 0.2s linear;

        &:hover {
            background-color: lighten(#5e3ed1, 7%);
        }
    }

    .application-icon-bg-green {
        background-color: #039c78;
        transition: 0.2s linear;

        &:hover {
            background-color: darken(#039c78, 5%);
        }
    }

    .application-icon-bg-default {
        background-color: #273246;
        transition: 0.2s linear;

        &:hover {
            background-color: lighten(#273246, 7%);
        }
    }

    .application-icon-bg-rms {
        background-color: #5da0b8;
        transition: 0.2s linear;

        &:hover {
            background-color: lighten(#273246, 7%);
        }
    }

}
</style>